var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationDot3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.3337 29.3333C41.3337 34.488 37.155 38.6667 32.0003 38.6667C26.8457 38.6667 22.667 34.488 22.667 29.3333C22.667 24.1787 26.8457 20 32.0003 20C37.155 20 41.3337 24.1787 41.3337 29.3333Z",
    stroke: "#1C2D37",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 5.3335C44.9883 5.3335 56 16.0881 56 29.1356C56 42.3908 44.8088 51.6927 34.472 58.018C33.7187 58.4434 32.8667 58.6668 32 58.6668C31.1333 58.6668 30.2813 58.4434 29.528 58.018C19.2104 51.6311 8 42.4367 8 29.1356C8 16.0881 19.0118 5.3335 32 5.3335Z",
    stroke: "#1C2D37",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationDot3);
export default __webpack_public_path__ + "static/media/location-dot3.ac1896c4449e756aa79f994d402b6bb6.svg";
export { ForwardRef as ReactComponent };